import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateSolicitudPrestacionesEspecialesByID = () => {
  const [loadingUpdateSolicitudPrestacionesEspecialesById, setLoadingCreateSolicitudPrestacionesEspeciales] = useState(false);
  const [successUpdateSolicitudPrestacionesEspecialesById, setSuccessCreateSolicitudPrestacionesEspeciales] = useState(false);
  const [errorUpdateSolicitudPrestacionesEspecialesById, setErrorCreateSolicitudPrestacionesEspeciales] = useState(null);
  const [dataUpdateSolicitudPrestacionesEspecialesById, setDataSolicitudPrestacionesEspeciales] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // UPDATE
  const updateSolicitudPrestacionesEspecialesById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateSolicitudPrestacionesEspeciales(true);
    setSuccessCreateSolicitudPrestacionesEspeciales(false);
    setErrorCreateSolicitudPrestacionesEspeciales(null);

    
    apiRecord.updateSolicitudComisionPrestacionesEspecialesByID(userId, formId, data)
      .then((res: any) => {
        setLoadingCreateSolicitudPrestacionesEspeciales(false);
        setSuccessCreateSolicitudPrestacionesEspeciales(true);
        setDataSolicitudPrestacionesEspeciales(res.data);

        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreateSolicitudPrestacionesEspeciales(false);
        setErrorCreateSolicitudPrestacionesEspeciales(err.response?.data);
      });
  };

  return {
    updateSolicitudPrestacionesEspecialesById,
    loadingUpdateSolicitudPrestacionesEspecialesById,
    successUpdateSolicitudPrestacionesEspecialesById,
    errorUpdateSolicitudPrestacionesEspecialesById,
    dataUpdateSolicitudPrestacionesEspecialesById
  };
};

export default useUpdateSolicitudPrestacionesEspecialesByID;
